import { requestGet } from '../../utils/request';

const BASE_URL = '/api/weather/v3';

export function requestCurrentConditions(fieldId) {
  return requestGet(
    `${BASE_URL}/current-conditions/fields?field-ids=${fieldId}`,
    {
      mockFile: 'weather/currentConditions',
    }
  );
}

export function requestHourlyForecast(fieldId) {
  return requestGet(
    `${BASE_URL}/hourly-forecast/fields?hours-forward=24&field-ids=${fieldId}`,
    {
      mockFile: 'weather/hourlyForecast',
    }
  );
}

export function requestDailyForecast(fieldId, isSprayAssistEnabled = false) {
  return requestGet(
    `${BASE_URL}/daily-forecast/fields?days-forward=7&field-ids=${fieldId}`,
    {
      headers: isSprayAssistEnabled ? {
        'include-spray': 'true'
      } : {},
      mockFile: 'weather/dailyForecast',
    }
  );
}